// extracted by mini-css-extract-plugin
module.exports = {"intro":"PageArticles_intro_YzfZF","headline":"PageArticles_headline_2W09H","listing":"PageArticles_listing_1_Lsl","teaser":"PageArticles_teaser_1VQ4P"};